export const SET_DEMO = "set_demo";
export const SET_HERO_HEIGHT = "set_hero_height";
export const SET_MODIFY_INTAKE_HEIGHT = "set_modify_intake_height";
export const UPDATE_TODAYS_INTAKE = "update_todays_intake";
export const UPDATE_TODAYS_INTAKE_DEMO = "update_todays_intake_demo";
export const SET_INTAKE_HEIGHT = "update_intake_height";
export const UPDATE_INTAKE = "update_intake";
export const SET_INTAKE_HISTORY_HEIGHT = "update_intake_history_height";
export const UPDATE_INTAKE_HISTORY = "update_intake_history";
export const UPDATE_INTAKE_DEMO = "update_intake_demo";
export const UPDATE_INTAKE_HISTORY_DEMO = "update_intake_history_demo";
